<template>
<div :style="{background:'#fff'}">
  <loading v-if="isShowLoading"></loading>
  <div class=" width-1200">
    <Breadcrumb separator="＞">
      <BreadcrumbItem :to="{name: 'hotel'}">酒店住宿</BreadcrumbItem>
      <BreadcrumbItem :to="`/hotelDetail/${this.$route.params.Id}`">酒店详情</span></BreadcrumbItem>
      <BreadcrumbItem>地址详情</BreadcrumbItem>
    </Breadcrumb>
  </div>
  <div class="amap-page-container">
      <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
      <el-amap v-if="mapCenter.length>0" vid="amapDemo" :plugin="plugin" :center="mapCenter" :zoom="12" class="amap-demo">
        <el-amap-marker v-if="markers.length>0" v-for="marker in markers" :position="marker" ></el-amap-marker>
        <!-- <el-amap-info-window :position="window.position">
          <div :style="slotStyle">
            <div class="wrapAmap"></div>
            <b :style="{color:'#f00'}">Hello {{ window.position }} times</b>
          </div>
        </el-amap-info-window> -->
      </el-amap>
  </div>
</div>
   
</template>
<script>
export default {
  data () {
    return {
      isShowLoading: false,
      plugin: [
        {
          pName: 'ToolBar',
          events: {
            init (instance) { console.log(instance); }
          }
        },
        {
          pName: 'MapType',
          defaultType: 0,
          events: {
            init (instance) {
              console.log(instance);
            }
          }
        }],
      slotStyle: {
        padding: '2px 8px',
        background: '#eee',
        color: '#333',
        border: '1px solid #aaa'
      },
      mapCenter: [],
      markers: [],
      window: { position: [] },
      searchOption: {
        // city: '上海',
        citylimit: false
      },
    }
  },
  mounted () {
    this.getHotelDetail()
  },
  methods: {
    onSearchResult (pois) {
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        pois.forEach(poi => {
          let { lng, lat } = poi;
          lngSum += lng;
          latSum += lat;
          this.markers.push([poi.lng, poi.lat]);
        });
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        };
        this.mapCenter = [center.lng, center.lat];
      }
    },
    getHotelDetail () {
      this.isShowLoading = true;
      let id = this.$route.params.Id;
      let queryUrl = `${this.baseURL}/sys/hotel/v1/shop/${id}`
      queryUrl += '?' + this.QS.stringify({
        // access_token: this.token,
      })
      this.$http.get(queryUrl).then(res => {
        let Data = res.data;
        this.isShowLoading = false;
        if (Data.code === 200) {
          let { location } = Data.data;
          let place = location.split(':');
          let [lon, lat] = place;
          let cation = [lat, lon]
          this.mapCenter = cation;
          this.markers.push(cation);
          this.window.position = cation
        }
      })
    },
  }
}
</script>
  <style>
.amap-demo {
  height: 300px;
}
.search-box {
  position: absolute;
  top: 70px;
  left: 80px;
}
.amap-page-container {
  position: relative;
  height: 750px;
  top: -45px;
}
</style>

